module.exports = __webpack_public_path__ + "img/globe-nav-chevron-down-darkgrey.aa16d4a3.svg";